import { render } from "./CancelPackage.vue?vue&type=template&id=12aba32f&scoped=true"
import script from "./CancelPackage.vue?vue&type=script&lang=js"
export * from "./CancelPackage.vue?vue&type=script&lang=js"

import "./CancelPackage.vue?vue&type=style&index=0&id=12aba32f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12aba32f"]])

export default __exports__